import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/common/Button';

const SlipDeleteConfirmationModal = ({ confirm, cancel }) => (
  <div className="modal">
    <div className="modal__header">Delete slip?</div>
    <p className="modal__paragraph">
      Are you sure you want to delete this slip?
    </p>
    <div className="modal__button-line">
      <Button className="modal__button button--secondary" onClick={cancel}>
        Cancel
      </Button>
      <Button className="modal__button" onClick={confirm}>
        Delete
      </Button>
    </div>
  </div>
);

SlipDeleteConfirmationModal.propTypes = {
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

export default SlipDeleteConfirmationModal;
